import { useIsMobile } from '../../../../../utils/getIsMobile';
import { CircularProgress } from '../../../../feedback/CircularProgress';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { MediaCover } from '../../../../media/MediaCover';
import { MediaPreview } from '../../../MediaPreview';
import { CardMediaProps } from './types';

export const CardMedia: React.FC<CardMediaProps> = ({
    media,
    index,
    ratio,
    containerRef,
    spinnerEnabled,
    mediaCoverEnabled,
    imageAlias,
    onClick,
    handleMouseOn,
    handleMouseOff,
}) => {
    const isMobile = useIsMobile();

    return (
        <MediaCover
            width="100%"
            height="100%"
            ratio={ratio}
            onClick={onClick}
            cursor="pointer"
            borderRadius={2}
            onMouseEnter={isMobile ? undefined : handleMouseOn}
            onMouseLeave={isMobile ? undefined : handleMouseOff}
            dataTestId={DataTestId.POST_CARD_GRID_MEDIA_COVER}
        >
            <Box ref={containerRef} />

            {mediaCoverEnabled || media.type !== 'video' ? (
                <MediaPreview lazyLoad={index > 0} media={media} imageAlias={imageAlias} />
            ) : null}

            {spinnerEnabled ? (
                <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    zIndex={10}
                    transform="translate(-50%, -50%)"
                    height="fit-content !important"
                    width="fit-content !important"
                >
                    <CircularProgress size={26} color="#FFFFFF" />
                </Box>
            ) : null}
        </MediaCover>
    );
};
